import { Component, OnDestroy, OnInit } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { LayoutService, NavbarBtn } from 'src/app/layout/layout.service';
import { ThirdPartyService } from '../../third-party.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConfigService } from 'src/app/services/config.service';
import { AdminService } from 'src/app/admin-pages/admin.service';

@Component({
  selector: 'app-servicenear-sellers-details',
  templateUrl: './servicenear-sellers-details.component.html',
  styleUrls: ['./servicenear-sellers-details.component.scss']
})
export class ServicenearSellersDetailsComponent implements OnInit , OnDestroy{

  subscription = new Subscription();
  page: number = 4;                     // tabs: 4 Subscription, 3 Invoice, 2 Old Invoices
  isV1PanelOpen: boolean = false;       // v1 billing details & actions panel under Username / psd
  loading: boolean = false;
  summaryLoading: boolean = false;
  sellerDetails: any = {};
  usageInvoices: any[] = [];
  branchID: number = 0;
  salesPOSSettings: any = {};
  sellerInfo: any = {};
  whatsAppForm: FormGroup;
  amountForm: FormGroup;
  adminDetails: any;
  bills: any[] = [];
  currentPlanInfo: any = null;          // subscription the edit/confirm actions apply to
  Uuid: string = '';
  subscriptionFeatures: any[] = [];
  activeSubscriptions: any[] = [];      // all running plans: { SubscriptionPlanHeader, SubscriptionPlanDetails }
  remoteConfig: any = null;             // /Servicenear/GetRemoteConfig response
  combinedFeatures: any[] = [];         // feature limits summed across running plans

  // --- Subscription edit modal state & helpers ---
  public subEditModalVisible: boolean = false;
  public subEditMode: 'validity' | 'grace' | 'feature' | 'addPlan' | 'priority' = 'validity';
  public subEditTitle: string = '';
  public activeFeature: any = null;
  public subscriptionForm: FormGroup;
  public availablePlans: any[] = [];
  public plansLoading: boolean = false;
  public selectedPlanId: number = 0;

  // --- Confirm modal state & helpers ---
  public confirmVisible: boolean = false;
  public confirmMessage: string = '';
  public confirmTitle: string = '';
  public confirmConfirmLabel: string = 'Confirm';
  public confirmCancelLabel: string = 'Cancel';
  public confirmAmount: boolean = false;
  private confirmCallback?: () => void;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;

  constructor(
    public layoutService: LayoutService,
    private thirdPartyService: ThirdPartyService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    public configService: ConfigService,
    private adminService: AdminService,
  ) { }

  get whatsAppEntries(): FormArray {
    return this.whatsAppForm.get('entries') as FormArray;
  }

  ngOnInit(): void {
    this.populateToolbarData();
    this.setAllForms();
    this.branchID = Number(this.route.snapshot.paramMap.get('branchID'));
    this.subscription.add(this.thirdPartyService.getSelectedSeller().subscribe(seller => {
      if (seller) {
        this.sellerInfo = seller;
      }else{
        this.setSellerInfo();
      }
    }));
    this.getSellerDetails();
    this.getUsageInvoicesByBranch();
    this.getRemoteConfig();
    this.adminDetails = this.thirdPartyService.getLoginDetails();

  }

  // Branch is listed in remote config tobeonline_users (v2 / Tobeonline branch)
  public get isTobeonlineBranch(): boolean {
    const tobeonlineBranches: any[] = Array.isArray(this.remoteConfig?.tobeonline_users) ? this.remoteConfig.tobeonline_users : [];
    return tobeonlineBranches.some((id: any) => Number(id) === Number(this.branchID));
  }

  // Migrated to v2 = Tobeonline branch AND has an active subscription
  public get isMigratedToV2(): boolean {
    return this.isTobeonlineBranch && this.activeSubscriptions.length > 0;
  }

  // Servicenear remote config - loaded once per page open; a failure leaves it null and the page works as before
  private getRemoteConfig() {
    this.subscription.add(this.thirdPartyService.getRemoteConfig().subscribe({
      next: (res: any) => {
        if (res?.Result === "Success") {
          let config = res.ResponseData ?? null;
          if (typeof config === 'string') {
            try { config = JSON.parse(config); } catch { config = null; }
          }
          this.remoteConfig = config;
        }
      },
      error: (err: any) => {
        this.remoteConfig = null;
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Customer Bills',
      isBack: true,
    });
    this.layoutService.setNavbarButtons([]);
  }

  private getSellerDetails() {
    this.summaryLoading = true;
    let params = {
      SecurityKey: 'serv$2015',
      BranchID: this.branchID
    }
    this.thirdPartyService.getBranchStatus(params).subscribe({
      next: (res: any) => {
        this.sellerDetails = res.ResponseData;
        this.salesPOSSettings = JSON.parse(this.sellerDetails.SalesPOSSettings || '{}');
        this.Uuid = this.salesPOSSettings?.SellerUnique;
        this.getCurrentPlanDetails();
        this.loadBills();
        this.summaryLoading = false;
      },
      error: (err: any) => {
        this.summaryLoading = false;
      }
    });
  }

  private getUsageInvoicesByBranch() {
    this.loading = true;
    let params = {
      securityKey: 'serv$2015',
      branchID: this.branchID
    }
    this.thirdPartyService.getUsageInvoicesByBranch(params).subscribe({
      next: (res: any) => {
        this.usageInvoices = (res.ResponseData || []).map((it: any) => ({ ...it, _showFullMessage: false }));
        // ensure form array matches invoices
        this.setWhatsAppFormArray();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      }
    });
  }

  private setAllForms(){
    this.whatsAppForm = this.fb.group({
      entries: this.fb.array([])
    });
    this.amountForm = this.fb.group({
      amount: [0]
    })
    this.subscriptionForm = this.fb.group({
      startDate: [''],
      endDate: [''],
      gracePeriodDate: [''],
      limitValue: [0],
      usage: [0],
      newPlanId: [0],
      selectNewDate: [false],
      newPlanStartDate: [''],
      newPlanEndDate: ['']
    })
  }

  private setWhatsAppFormArray() {
    // clear existing
    const arr = this.whatsAppEntries;
    while (arr.length) arr.removeAt(0);

    this.usageInvoices.forEach((it: any) => {
      const phone = it?.BranchContact || it?.Contact || this.sellerInfo?.BranchContact || '';
      arr.push(this.fb.group({
        phoneNo: [phone, [Validators.required]]
      }));
    });
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 2000);
  }

  private loadBills() {
    forkJoin({
      history: this.configService.getSubscriptionBillsHistoryBySellerUuid({uuid: this.Uuid}),
      pending: this.configService.getPendingPaymentBySellerUuid({uuid: this.Uuid})
    }).subscribe(({ history, pending }: any) => {
      const historyArr = history.ResponseData || [];
      const pendingArr = pending.ResponseData || [];

      const historyWithFlag = historyArr.map(item => ({
        ...item,
        isPendingBill: false  
      }));

      const pendingWithFlag = pendingArr.map(item => ({
        ...item,
        isPendingBill: true
      }));

      this.bills = [...pendingWithFlag, ...historyWithFlag];
      this.calculateBillTotals();
    });
  }

  // Pending bills total shown under the old details panel
  public billTotals = { pending: 0, pendingCount: 0 };

  private calculateBillTotals() {
    const pendingBills = this.bills.filter((bill: any) => bill?.isPendingBill);
    this.billTotals = {
      pending: pendingBills.reduce((sum: number, bill: any) => sum + (Number(bill?.TotalAmount) || 0), 0),
      pendingCount: pendingBills.length,
    };
  }

  private setSellerInfo(){
    let params = {
      BranchType: 'All'
    }
    this.thirdPartyService.getBranchWorkCountDetails(params).subscribe({
      next: (res: any) => {
        const branches = res.ResponseData;
        const sllr = branches.filter((b: any)=> b.BranchID == this.branchID)
        this.sellerInfo = sllr[0];
      },
      error: (err: any) => {
      }
    });
  }

  private getCurrentPlanDetails() {

    this.configService.getCurrentPlanBySellerUuid({uuid: this.Uuid}).subscribe((res: any) => {
      if(res?.Result === "Success"){
        const subscriptiondetails = res.ResponseData;
        // Shown in the order limits are consumed: priority -> ends soonest -> oldest
        const currentPlanDetails = (subscriptiondetails?.Subscriptions ?? [])
          .filter((s: any) => s?.SubscriptionPlanHeader)
          .sort((a: any, b: any) => this.compareUsageOrder(a.SubscriptionPlanHeader, b.SubscriptionPlanHeader));
        this.activeSubscriptions = currentPlanDetails;
        this.combinedFeatures = this.buildCombinedFeatures(currentPlanDetails);

        // keep the previously selected subscription selected after a refresh
        const selectedId = this.currentPlanInfo?.CustomerSubscriptionID;
        const selected = currentPlanDetails.find((s: any) => s.SubscriptionPlanHeader.CustomerSubscriptionID === selectedId) ?? currentPlanDetails[0];
        this.currentPlanInfo = selected?.SubscriptionPlanHeader ?? null;
        this.subscriptionFeatures = selected?.SubscriptionPlanDetails ?? [];

        // plan catalog gives the price shown in the header (also reused by the Add Plan picker)
        if (currentPlanDetails.length > 0 && this.availablePlans.length === 0 && !this.plansLoading) {
          this.loadAvailablePlans();
        }
      }

    })
  }

  // Same rule as the backend: COUNT limits add up across running plans, VALIDITY = unlimited
  private buildCombinedFeatures(subscriptions: any[]): any[] {
    const map = new Map<string, any>();
    subscriptions.forEach((sub: any) => {
      (sub?.SubscriptionPlanDetails ?? []).forEach((f: any) => {
        const key = f?.FeatureUniq || f?.Name;
        if (!key) return;
        const item = map.get(key) ?? { Name: f?.FeatureName || f?.Name, FeatureUniq: f?.FeatureUniq, RuleType: f?.RuleType, LimitValue: 0, Usage: 0 };
        if ((f?.RuleType || '').toUpperCase() === 'VALIDITY') {
          item.RuleType = 'VALIDITY';
        }
        item.LimitValue += Number(f?.LimitValue) || 0;
        item.Usage += Number(f?.Usage) || 0;
        map.set(key, item);
      });
    });
    return Array.from(map.values());
  }

  // Mirrors sp_IncrementConcurrentSubscriptionUsage ORDER BY
  private compareUsageOrder(a: any, b: any): number {
    const pa = a?.EffectiveUsagePriority ?? 100;
    const pb = b?.EffectiveUsagePriority ?? 100;
    if (pa !== pb) return pa - pb;
    const ea = a?.EndDateUnix || Number.MAX_SAFE_INTEGER;
    const eb = b?.EndDateUnix || Number.MAX_SAFE_INTEGER;
    if (ea !== eb) return ea - eb;
    return (a?.CustomerSubscriptionID ?? 0) - (b?.CustomerSubscriptionID ?? 0);
  }

  // Price from the plan catalog (subscription_plan.Price); '--' until the catalog has loaded
  public getPlanPriceLabel(sub: any): string {
    const plan = this.availablePlans.find((p: any) => p?.ID === sub?.SubscriptionPlanHeader?.SubscriptionPlanID);
    if (!plan) return '--';
    const price = Number(plan.Price) || 0;
    return price > 0 ? '₹' + price.toLocaleString('en-IN') : 'Free';
  }

  public sendWhatsApp(index: number, item?: any) {
    const control = this.whatsAppEntries.at(index);
    if (!control) return console.warn('No form control for index', index);
    const phoneRaw = control.get('phoneNo')?.value || '';
    const digits = (phoneRaw || '').toString().replace(/\D/g, '');
    if (!digits) return alert('Phone number is empty');

    const phoneForWA = digits.length === 10 ? '91' + digits : digits;
    const msg = item?.BillMessage || '';
    const url = `https://wa.me/${phoneForWA}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  }

  public onPayBill() {
    const amount = this.amountForm.get('amount')?.value;
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      invoiceDate: '',
      amount: String(amount)
    }
    this.thirdPartyService.updatePaymentStatus(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success" && res?.ResponseData == "Success"){
          this.notify(true, 'Payment updated successfully');
          this.getSellerDetails();
        }else{
          this.notify(false, 'Payment updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Payment updation failed');
      }
    });

  }

  public onUpdateCredit() {
    const amount = this.amountForm.get('amount')?.value;
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      monthlyCreditLimit: String(amount)
    }
    this.thirdPartyService.updateMonthlyCreditLimit(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success" && res?.ResponseData == "Success"){
          this.notify(true, 'Monthly credit limit updated successfully');
          this.getSellerDetails();
        }else{
          this.notify(false, 'Monthly credit limit updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Monthly credit limit updation failed');
      }
    });
  }

  public onMigrateSeller() {
    const params = {
      branchId: this.branchID
    }
    this.thirdPartyService.migrateServicenearBranchToV2(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success" && res?.ResponseData == "Success"){
          this.notify(true, 'Branch migrated successfully');
          this.getSellerDetails();
        }else{
          this.notify(false, 'Branch migration failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Branch migration failed');
      }
    });
  }

  public toggleBanner() {
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID
    }
    this.thirdPartyService.changePaymentBannerStatus(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success"){
          if(res?.ResponseData == "enabled"){
            this.notify(true, 'Payment banner enabled successfully');
          }else if(res?.ResponseData == "disabled"){
            this.notify(true, 'Payment banner disabled successfully');
          }
          this.getSellerDetails();
        }else{
          this.notify(false, 'Payment banner updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Payment banner updation failed');
      }
    });
  }

  public toggleWhatsapp() {
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      statusType: "Whatsapp"
    }
    this.thirdPartyService.updateDifferentStatusesByType(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success"){
          if(res?.ResponseData == "enabled"){
            this.notify(true, 'Whatsapp enabled successfully');
          }else if(res?.ResponseData == "disabled"){
            this.notify(true, 'Whatsapp disabled successfully');
          }
          this.getSellerDetails();
        }else{
          this.notify(false, 'Whatsapp updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Whatsapp updation failed');
      }
    });
  }

  public toggleCoreUser() {
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      statusType: "CoreUser"
    }
    this.thirdPartyService.updateDifferentStatusesByType(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success"){
          if(res?.ResponseData == "enabled"){
            this.notify(true, 'Core user enabled successfully');
          }else if(res?.ResponseData == "disabled"){
            this.notify(true, 'Core user disabled successfully');
          }
          this.getSellerDetails();
        }else{
          this.notify(false, 'Core user updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Core user updation failed');
      }
    });
  }

  public changePage(page: number) {
    this.page = page;
  }

  public toggleMessage(item: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    item._showFullMessage = !item._showFullMessage;
  }

  public isLongMessage(msg?: string): boolean {
    return !!msg && msg.length > 120;
  }

  public formatUnixToReadable(unixTimestamp: number): string {
    if (!unixTimestamp) return '';

    return moment.unix(unixTimestamp).format('DD MMM YY, hh:mm a');
  }

  public copyContactNumber() {
    const number = this.sellerInfo?.BranchContact;

    if (!number) return;

    navigator.clipboard.writeText(number).then(() => {
      this.notify(true, 'Contact number copied to clipboard');
    });
  }

  public callThisNumber(){
    const phone = this.sellerInfo?.BranchContact;
    if (!phone) return;

    window.open(`tel:${phone}`, '_self');
  }

  public whatsAppThisNumber() {
    const phone = this.sellerInfo?.BranchContact;
    if (!phone) return;

    // Remove spaces or special chars
    const formatted = phone.replace(/[^0-9]/g, '');
    const whatsappNum = '91' + formatted;

    // WhatsApp API link
    const url = `https://wa.me/${whatsappNum}`;
    window.open(url, '_blank');
  }

  public showConfirm(message: string, callback: () => void, confirmtitle?: string, amountReq?: boolean, confirmLabel?: string, cancelLabel?: string) {
    this.confirmMessage = message;
    this.confirmCallback = callback;
    this.confirmTitle = confirmtitle || 'Confirm Action';
    this.confirmConfirmLabel = confirmLabel || 'Confirm';
    this.confirmCancelLabel = cancelLabel || 'Cancel';
    this.confirmAmount = amountReq;
    this.confirmVisible = true;
  }

  public confirmCancel() {
    this.confirmVisible = false;
    this.confirmCallback = undefined;
  }

  public confirmOK() {
    if (this.confirmCallback) {
      try {
        this.confirmCallback();
      } catch (e) {
        console.error('Error executing confirm callback', e);
      }
    }
    this.confirmCancel();
  }

  // convenience wrappers for actions on Page 1
  public confirmPayBill() {
    this.amountForm.reset();
    const aboutSeller = `${this.sellerInfo?.BranchName}(${this.sellerInfo.Place}) - ${this.sellerInfo.BranchContact}`
    this.showConfirm(`To pay: ${this.sellerDetails.PendingBillAmount}`, () => this.onPayBill(), aboutSeller, true,"Save Payment");
  }

  public confirmUpdateCredit() {
    this.amountForm.reset();
    const aboutSeller = `${this.sellerInfo?.BranchName}(${this.sellerInfo.Place}) - ${this.sellerInfo.BranchContact}`
    this.showConfirm(`Current credit limit : ${this.sellerDetails.MonthlyCredit}`, () => this.onUpdateCredit(), aboutSeller, true, "Change Credit Limit");
  }

  public confirmToggleBanner() {
    const action = this.sellerDetails.EnablePaymentBanner ? 'Disable' : 'Enable';
    this.showConfirm(`${action} payment banner?`, () => this.toggleBanner());
  }

  public confirmToggleWhatsapp() {
    const action = this.sellerDetails.WhatsappEnabled ? 'Disable' : 'Enable';
    this.showConfirm(`${action} Whatsapp for this seller?`, () => this.toggleWhatsapp());
  }

  public confirmToggleCoreUser() {
    const action = this.sellerDetails.CoreUser ? 'Revoke' : 'Make';
    this.showConfirm(`${action} core user status?`, () => this.toggleCoreUser());
  }

  public confirmMigrateSeller() {
    // Re-running for an already migrated branch updates its existing V2 details (pending items get synced)
    if (this.isTobeonlineBranch) {
      this.showConfirm('This branch is already migrated. Running it again will update the existing V2 details and sync anything pending. Continue?',
        () => this.onMigrateSeller(), "Update V2 Details", false, "Update", "");
      return;
    }
    this.showConfirm('Confirm migrate seller?', () => this.onMigrateSeller(),"Migrate Seller", false, "Migrate","");
  }

  // --- Pending bill actions (Invoice tab) ---

  public confirmEditBillAmount(bill: any) {
    this.amountForm.reset();
    this.amountForm.patchValue({ amount: bill?.TotalAmount });
    this.showConfirm(`Current bill amount : ${bill?.TotalAmount}`, () => this.onUpdateBillAmount(bill), bill?.PlanName || 'Update Bill Amount', true, "Save Amount");
  }

  public onUpdateBillAmount(bill: any) {
    const amount = this.amountForm.get('amount')?.value;
    const params = {
      uuid: this.Uuid,
      orderId: bill?.OrderID,
      amount: amount
    };
    this.thirdPartyService.updateSubscriptionBillAmountBySellerUuid(params).subscribe({
      next: (res: any) => {
        if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
          this.notify(true, 'Bill amount updated successfully');
          this.loadBills();
        } else {
          this.notify(false, 'Bill amount update failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Bill amount update failed');
      }
    });
  }

  // Payment of a bill is updated on its order - open the order detail page
  public openBillOrder(bill: any) {
    if (!bill?.OrderID) return;
    this.router.navigate(['/sales/allorder-detail', bill.OrderID]);
  }

  // --- Subscription management (page 4) ---

  public isGracePeriodExpired(planHeader: any = this.currentPlanInfo): boolean {
    const grace = planHeader?.PaymentGracePeriod;
    if (!grace) return false;
    return Math.floor(Date.now() / 1000) > grace;
  }

  // Points every edit/confirm action at the given plan card
  public selectSubscription(sub: any) {
    if (!sub?.SubscriptionPlanHeader) return;
    this.currentPlanInfo = sub.SubscriptionPlanHeader;
    this.subscriptionFeatures = sub.SubscriptionPlanDetails ?? [];
  }

  public openUpdateValidity(sub?: any) {
    this.selectSubscription(sub);
    this.subEditMode = 'validity';
    this.subEditTitle = 'Update Subscription Validity';
    this.subscriptionForm.reset();
    this.subscriptionForm.patchValue({
      startDate: this.unixToDateInputStr(this.currentPlanInfo?.StartDateUnix),
      endDate: this.unixToDateInputStr(this.currentPlanInfo?.EndDateUnix)
    });
    this.subEditModalVisible = true;
  }

  public openUpdateGracePeriod(sub?: any) {
    this.selectSubscription(sub);
    this.subEditMode = 'grace';
    this.subEditTitle = 'Update Payment Grace Period';
    this.subscriptionForm.reset();
    this.subscriptionForm.patchValue({
      gracePeriodDate: this.unixToDateInputStr(this.currentPlanInfo?.PaymentGracePeriod)
    });
    // highlight the preset that matches the saved date, otherwise treat it as a custom date
    const days = this.graceDaysFromEnd;
    this.graceCustomMode = days === null || !this.gracePresetDays.includes(days);
    this.subEditModalVisible = true;
  }

  // --- Grace period presets: N days after the plan end date, or a custom date ---
  public readonly gracePresetDays: number[] = [5, 10, 15, 30];
  public graceCustomMode: boolean = false;

  /** Grace days are counted from the plan end date; plans without an end date count from today. */
  public get graceBaseDate(): moment.Moment {
    const endUnix = this.currentPlanInfo?.EndDateUnix;
    return (endUnix ? moment.unix(endUnix) : moment()).startOf('day');
  }

  public get graceBaseLabel(): string {
    return this.currentPlanInfo?.EndDateUnix ? 'plan end date' : 'today';
  }

  /** Days between the base date and the chosen grace date; null when no date is chosen. */
  public get graceDaysFromEnd(): number | null {
    const dateStr = this.subscriptionForm?.value?.gracePeriodDate;
    if (!dateStr) return null;
    return moment(dateStr, 'YYYY-MM-DD').startOf('day').diff(this.graceBaseDate, 'days');
  }

  public selectGracePreset(days: number) {
    this.graceCustomMode = false;
    this.subscriptionForm.patchValue({
      gracePeriodDate: this.graceBaseDate.clone().add(days, 'days').format('YYYY-MM-DD')
    });
  }

  public selectGraceCustom() {
    this.graceCustomMode = true;
  }

  public get isGraceSaveDisabled(): boolean {
    if (this.subEditMode !== 'grace') return false;
    const days = this.graceDaysFromEnd;
    return days === null || days < 0;
  }

  public openFeatureEdit(feature: any, sub?: any) {
    this.selectSubscription(sub);
    this.subEditMode = 'feature';
    this.subEditTitle = `Update Limit / Usage - ${feature?.Name || feature?.FeatureUniq || ''}`;
    this.activeFeature = feature;
    this.subscriptionForm.reset();
    this.subscriptionForm.patchValue({
      limitValue: feature?.LimitValue ?? 0,
      usage: feature?.Usage ?? 0
    });
    this.subEditModalVisible = true;
  }

  // --- Usage order: which running plan's limit is used first (drag or tap arrows) ---
  public usageOrderList: any[] = [];

  public openUsageOrder() {
    this.subEditMode = 'priority';
    this.subEditTitle = 'Plan Usage Order';
    this.usageOrderList = [...this.activeSubscriptions];   // already sorted in usage order
    this.subEditModalVisible = true;
  }

  public dropUsageOrder(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.usageOrderList, event.previousIndex, event.currentIndex);
  }

  public moveUsageOrder(index: number, direction: -1 | 1) {
    const target = index + direction;
    if (target < 0 || target >= this.usageOrderList.length) return;
    moveItemInArray(this.usageOrderList, index, target);
  }

  // Count-limit usage shown on each row (CREATE_JOB preferred, else the first COUNT feature)
  public getUsageSummary(sub: any): { used: number, limit: number, percent: number, isFull: boolean } | null {
    const countFeatures = (sub?.SubscriptionPlanDetails ?? []).filter((f: any) => (f?.RuleType || '').toUpperCase() === 'COUNT');
    const feature = countFeatures.find((f: any) => f?.FeatureUniq === 'CREATE_JOB') ?? countFeatures[0];
    if (!feature) return null;
    const used = Number(feature.Usage) || 0;
    const limit = Number(feature.LimitValue) || 0;
    return {
      used,
      limit,
      percent: limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0,
      isFull: limit > 0 && used >= limit
    };
  }

  // Row "Cancel" = cancel that plan; closes the order popup and asks for confirmation first
  public cancelPlanFromUsageOrder(sub: any) {
    this.closeSubEditModal();
    this.confirmCancelSubscriptionPlanFor(sub);
  }

  public get isUsageOrderChanged(): boolean {
    return this.usageOrderList.some((sub: any, i: number) =>
      sub !== this.activeSubscriptions[i] || sub.SubscriptionPlanHeader?.UsagePriority == null);
  }

  public get isPrioritySaveDisabled(): boolean {
    return this.subEditMode === 'priority' && (this.usageOrderList.length < 2 || !this.isUsageOrderChanged);
  }

  private saveUsageOrder() {
    const params = {
      uuid: this.Uuid,
      subscriptionIds: this.usageOrderList.map((sub: any) => sub.SubscriptionPlanHeader?.CustomerSubscriptionID)
    };
    this.thirdPartyService.updateSubscriptionUsageOrderBySellerUuid(params).subscribe({
      next: (res: any) => {
        if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
          this.notify(true, 'Plan usage order updated successfully');
          this.getSellerDetails();
        } else {
          this.notify(false, (typeof res?.ResponseData === 'string' && res.ResponseData) || 'Plan usage order update failed');
        }
        this.closeSubEditModal();
      },
      error: (err: any) => {
        this.notify(false, 'Plan usage order update failed');
      }
    });
  }

  // Add another plan alongside the running plan(s); the current plan is not switched or expired
  public openAddPlan() {
    if (!this.isTobeonlineBranch) return;   // Add Plan only for branches in tobeonline_users
    this.subEditMode = 'addPlan';
    this.subEditTitle = 'Add Subscription Plan';
    this.subscriptionForm.reset();
    this.selectedPlanId = 0;
    this.addPlanSaving = false;
    this.subEditModalVisible = true;
    if (this.availablePlans.length === 0) {
      this.loadAvailablePlans();
    }
  }

  // Plan picker chip, e.g. CREATE_JOB COUNT 50 -> "JOB LIMIT 50"; VALIDITY -> "JOB UNLIMITED"
  public getPlanFeatureLimitLabel(feature: any): string {
    const uniq = (feature?.FeatureUniq || '').toUpperCase();
    const name = uniq === 'CREATE_JOB' ? 'JOB' : (feature?.FeatureName || uniq).toUpperCase();
    return (feature?.RuleType || '').toUpperCase() === 'VALIDITY'
      ? `${name} UNLIMITED`
      : `${name} LIMIT ${Number(feature?.LimitValue) || 0}`;
  }

  // --- Plan details popup ("View details" in the Add Plan list) ---
  public planDetails: any = null;

  public openPlanDetails(plan: any, event?: Event) {
    event?.stopPropagation();   // don't select the row
    this.planDetails = plan;
  }

  public closePlanDetails() {
    this.planDetails = null;
  }

  public selectPlanFromDetails() {
    if (this.planDetails) {
      this.selectPlan(this.planDetails);
    }
    this.closePlanDetails();
  }

  // Description comes from the plan's product and may contain HTML from the product editor - shown as plain text
  public getPlanDescription(plan: any): string {
    const raw = plan?.Description || plan?.ShortDescription || '';
    return raw.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // Modules the plan grants (show && !disable in its FeatureAccess JSON), combined across its features
  public getPlanModules(plan: any): string[] {
    const modules = new Set<string>();
    (plan?.Features ?? []).forEach((feature: any) => {
      let access: any = feature?.FeatureAccess;
      if (typeof access === 'string') {
        try { access = JSON.parse(access); } catch { access = null; }
      }
      if (!access || typeof access !== 'object') return;
      Object.keys(access).forEach((key: string) => {
        const item = access[key];
        if (item && typeof item === 'object' && !Array.isArray(item) && item.show === true && item.disable !== true) {
          modules.add(key);
        }
      });
    });
    return Array.from(modules);
  }

  public getPlanAddOns(plan: any): any[] {
    if (!plan?.ID || plan?.ParentPlanID) return [];
    return this.availablePlans.filter((p: any) => p?.ParentPlanID === plan.ID);
  }

  // Add-on plans are attached automatically by the usage flow, so only main plans can be added here
  public get addablePlans(): any[] {
    return this.availablePlans.filter((plan: any) => !plan?.ParentPlanID);
  }

  public isPlanRunning(planId: number): boolean {
    return this.activeSubscriptions.some((s: any) => s.SubscriptionPlanHeader?.SubscriptionPlanID === planId);
  }

  private loadAvailablePlans() {
    this.plansLoading = true;
    this.thirdPartyService.getAllSubscriptionPlansForSuperAdmin({ uuid: this.Uuid }).subscribe({
      next: (res: any) => {
        if (res?.Result === "Success" && res?.ResponseData) {
          this.availablePlans = res.ResponseData;
        }
        this.plansLoading = false;
      },
      error: (err: any) => {
        this.plansLoading = false;
      }
    });
  }

  // Add Plan: one plan per popup; while saving, Save is disabled so it can't be added twice
  public addPlanSaving: boolean = false;

  public selectPlan(plan: any) {
    this.selectedPlanId = plan?.ID;
    this.subscriptionForm.patchValue({
      newPlanId: plan?.ID
    });
  }

  public get isAddPlanSaveDisabled(): boolean {
    if (this.subEditMode !== 'addPlan') return false;
    if (!this.selectedPlanId) return true;
    if (this.addPlanSaving) return true;
    const v = this.subscriptionForm.value;
    if (v.selectNewDate && (!v.newPlanStartDate || !v.newPlanEndDate)) return true;
    if (v.selectNewDate && v.newPlanEndDate < v.newPlanStartDate) return true;
    return false;
  }

  public confirmToggleSubscriptionExpiredFor(sub: any) {
    this.selectSubscription(sub);
    this.confirmToggleSubscriptionExpired();
  }

  public confirmCancelSubscriptionPlanFor(sub: any) {
    this.selectSubscription(sub);
    this.confirmCancelSubscriptionPlan();
  }

  public closeSubEditModal() {
    this.subEditModalVisible = false;
    this.planDetails = null;
    this.activeFeature = null;
    this.selectedPlanId = 0;
  }

  public confirmToggleSubscriptionExpired() {
    const action = this.currentPlanInfo?.IsExpired ? 'Reactivate' : 'Mark Expired';
    this.showConfirm(`${action} this subscription plan?`, () => this.onToggleSubscriptionExpired(), 'Subscription Status', false, action, '');
  }

  public onToggleSubscriptionExpired() {
    const params = {
      uuid: this.Uuid,
      subscriptionId: this.currentPlanInfo?.CustomerSubscriptionID,
      isExpired: !this.currentPlanInfo?.IsExpired
    };
    this.thirdPartyService.updateSubscriptionExpiredStatusBySellerUuid(params).subscribe({
      next: (res: any) => {
        if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
          this.notify(true, 'Subscription status updated successfully');
          this.getSellerDetails();
        } else {
          this.notify(false, 'Subscription status update failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Subscription status update failed');
      }
    });
  }

  public confirmCancelSubscriptionPlan() {
    this.showConfirm('Cancel this subscription plan? This will deactivate it.', () => this.onCancelSubscriptionPlan(), 'Cancel Subscription', false, 'Cancel Plan', 'Back');
  }

  public onCancelSubscriptionPlan() {
    const params = {
      uuid: this.Uuid,
      subscriptionId: this.currentPlanInfo?.CustomerSubscriptionID
    };
    this.thirdPartyService.cancelSubscriptionBySellerUuid(params).subscribe({
      next: (res: any) => {
        if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
          this.notify(true, 'Subscription plan cancelled successfully');
          this.getSellerDetails();
        } else {
          this.notify(false, 'Subscription plan cancellation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Subscription plan cancellation failed');
      }
    });
  }

  public saveSubscriptionEdit() {
    const formValue = this.subscriptionForm.value;
    const subscriptionId = this.currentPlanInfo?.CustomerSubscriptionID;

    if (this.subEditMode === 'validity') {
      const params = {
        uuid: this.Uuid,
        subscriptionId,
        startDateUnix: this.dateInputStrToUnix(formValue.startDate, false),
        endDateUnix: this.dateInputStrToUnix(formValue.endDate, true)
      };
      this.thirdPartyService.updateSubscriptionValidityBySellerUuid(params).subscribe({
        next: (res: any) => {
          if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
            this.notify(true, 'Subscription validity updated successfully');
            this.getSellerDetails();
          } else {
            this.notify(false, 'Subscription validity update failed');
          }
          this.closeSubEditModal();
        },
        error: (err: any) => {
          this.notify(false, 'Subscription validity update failed');
        }
      });
    } else if (this.subEditMode === 'grace') {
      const params = {
        uuid: this.Uuid,
        subscriptionId,
        paymentGracePeriodUnix: this.dateInputStrToUnix(formValue.gracePeriodDate, true)
      };
      this.thirdPartyService.updateSubscriptionGracePeriodBySellerUuid(params).subscribe({
        next: (res: any) => {
          if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
            this.notify(true, 'Payment grace period updated successfully');
            this.getSellerDetails();
          } else {
            this.notify(false, 'Payment grace period update failed');
          }
          this.closeSubEditModal();
        },
        error: (err: any) => {
          this.notify(false, 'Payment grace period update failed');
        }
      });
    } else if (this.subEditMode === 'feature') {
      const params = {
        uuid: this.Uuid,
        detailId: this.activeFeature?.CustomerSubscriptionDetailsID,
        limitValue: Number(formValue.limitValue),
        usage: Number(formValue.usage)
      };
      this.thirdPartyService.updateSubscriptionFeatureLimitUsageBySellerUuid(params).subscribe({
        next: (res: any) => {
          if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
            this.notify(true, 'Feature limit/usage updated successfully');
            this.getSellerDetails();
          } else {
            this.notify(false, 'Feature limit/usage update failed');
          }
          this.closeSubEditModal();
        },
        error: (err: any) => {
          this.notify(false, 'Feature limit/usage update failed');
        }
      });
    } else if (this.subEditMode === 'priority') {
      this.saveUsageOrder();
    } else if (this.subEditMode === 'addPlan') {
      const selectNewDate = !!formValue.selectNewDate;
      const params = {
        uuid: this.Uuid,
        planId: Number(formValue.newPlanId),
        // no custom dates -> backend starts today and ends per the plan's bill cycle
        startDateUnix: selectNewDate ? this.dateInputStrToUnix(formValue.newPlanStartDate, false) : null,
        endDateUnix: selectNewDate ? this.dateInputStrToUnix(formValue.newPlanEndDate, true) : null
      };
      this.addPlanSaving = true;
      this.thirdPartyService.addSubscriptionPlanBySellerUuid(params).subscribe({
        next: (res: any) => {
          this.addPlanSaving = false;
          if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
            this.notify(true, 'Subscription plan added successfully');
            this.getSellerDetails();
            this.closeSubEditModal();
          } else {
            // keep the popup open so another plan can be picked
            this.notify(false, (typeof res?.ResponseData === 'string' && res.ResponseData) || 'Adding subscription plan failed');
          }
        },
        error: (err: any) => {
          this.addPlanSaving = false;
          this.notify(false, 'Adding subscription plan failed');
        }
      });
    }
  }

  private unixToDateInputStr(unix?: number): string {
    if (!unix) return '';
    return moment.unix(unix).format('YYYY-MM-DD');
  }

  private dateInputStrToUnix(dateStr: string, endOfDay: boolean): number {
    if (!dateStr) return 0;
    const m = endOfDay ? moment(dateStr, 'YYYY-MM-DD').endOf('day') : moment(dateStr, 'YYYY-MM-DD').startOf('day');
    return m.unix();
  }

}
